import type { MouseEvent } from "react";
import { helpers } from "../../util/helpers.ts";
import { toWorker } from "../../util/toWorker.ts";
import { useViewData } from "../../util/viewManager.tsx";
import i18n from "../../util/i18n.ts";
import {
	shouldRenderMobilePrimaryCTA,
	type RegisteredMobilePrimaryCTA,
} from "./mobilePrimaryCTAState.ts";

const handleRegisteredClick = (
	cta: RegisteredMobilePrimaryCTA,
	event: MouseEvent,
) => {
	if (cta.worker) {
		event.preventDefault();
		toWorker("playMenu", cta.worker.id as any, undefined);
	}
};

export const MobilePrimaryCTA = () => {
	const viewInfo = useViewData();
	const inLeague = viewInfo?.inLeague;
	const pageID = viewInfo?.idLoading ?? viewInfo?.idLoaded;
	const cta = viewInfo.data.mobilePrimaryCTA as
		| RegisteredMobilePrimaryCTA
		| undefined;

	if (
		cta === undefined ||
		!shouldRenderMobilePrimaryCTA({ cta, inLeague, pageID })
	) {
		return null;
	}

	const label = i18n.t(cta.labelKey, {
		ns: "ui",
		defaultValue: cta.defaultLabel,
	});
	const href = cta.url ?? (cta.path ? helpers.leagueUrl(cta.path) : undefined);
	const className =
		"mobile-primary-cta mobile-primary-cta-button btn btn-primary border-0 shadow";

	if (!href) {
		return (
			<button
				aria-label={label}
				className={className}
				onClick={(event) => handleRegisteredClick(cta, event)}
				type="button"
			>
				{label}
			</button>
		);
	}

	return (
		<a
			aria-label={label}
			className={className}
			href={href}
			onClick={(event) => handleRegisteredClick(cta, event)}
		>
			{label}
		</a>
	);
};

export default MobilePrimaryCTA;
